export default __webpack_public_path__ + "474d23ec19131f1693044f7ec7a2333d.png";